import { StyleSheet } from 'react-native';
import { getBoxShadow } from 'src/helpers/style.helper';
import { brand, neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  functionBar: {
    width: '100%',
    gap: 16,
    paddingHorizontal: 32,
    paddingTop: 8,
    paddingBottom: 24,
    borderBottomWidth: 1,
    borderColor: neutrals.coldGrays.fog,
  },
  text: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 18,
    color: neutrals.neutralGrays.smoke,
  },
  button: {
    width: '100%',
    height: '100%',
    borderRadius: 20,
    backgroundColor: neutrals.coldGrays.ice,
    gap: 4,
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonIcon: {
    width: 33,
    height: 33,
  },
  buttonText: {
    color: brand.main.water,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 18,
    letterSpacing: 0.16,
    paddingHorizontal: 16,
    textAlign: 'center',
  },
  dropdown: {
    position: 'absolute',
    zIndex: 50,
    width: 430,
    left: 32,
    top: 116,
  },
  footer: {
    padding: 24,
    height: 87,
    shadowColor: neutrals.black,
    shadowOpacity: 0.3,
    shadowRadius: 9,
    shadowOffset: {
      width: -0.5,
      height: -0.5,
    },
  },
  textLink: {
    color: brand.main.water,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 16,
    borderWidth: 0,
    borderColor: brand.main.water,
  },
  pickerButton: {
    backgroundColor: neutrals.white,
    borderRadius: 50,
    height: 38,
    alignItems: 'center',
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 0,
    justifyContent: 'center',
    width: 209,
    ...getBoxShadow({
      offsetX: 3,
      offsetY: 3,
      blurRadius: 8,
      opacity: 0.1,
      color: neutrals.black,
    }),
  },
  pickerButtonTop: {
    backgroundColor: neutrals.white,
    borderRadius: 20,
    height: 40,
    alignItems: 'center',
    ...getBoxShadow({
      offsetX: 3,
      offsetY: 3,
      blurRadius: 8,
      opacity: 0.1,
      color: neutrals.black,
    }),
    justifyContent: 'center',
  },
  pickerButtonHover: {
    backgroundColor: neutrals.coldGrays.pearl,
  },
  sourcesWrapper: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    rowGap: 12,
    columnGap: 12,
    justifyContent: 'center',
  },
  cta: {
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingVertical: 12,
    paddingHorizontal: 32,
  },
  emptyStateContainer: { flex: 1, justifyContent: 'center', alignItems: 'center', gap: 16 },
  emptyStateText: { fontWeight: 400, fontSize: 16, lineHeight: 20, textAlign: 'center' },
});
